export default {
    reviews: [],
    reviewCount: 0
}